export default __webpack_public_path__ + "static/img_product_olb@2x-fef342238aeb2069b8bc6b2f7975c73c.png";